import {APPEND_TO_PAYLOAD} from '../constants';
import log from '../log';

export default function validateProps(props) {
	if (!props[APPEND_TO_PAYLOAD]) return props;

	const {[APPEND_TO_PAYLOAD]: appendToPayload, ...nonAppendProps} = props;
	if (appendToPayload && typeof appendToPayload !== 'object') {
		log(`Expected ${APPEND_TO_PAYLOAD} property to be an Object. Found ${appendToPayload}`, {
			origin: 'validateProps'
		});
		return nonAppendProps;
	}

	return props;
}
